/**
 * useBreadcrumb — module-level singleton so any component can set
 * the human-readable title for the current detail page, and AppTopBar
 * can read it to replace the numeric ID segment in the breadcrumb trail.
 */
import { ref } from 'vue'

const breadcrumbTitle = ref('')

export function useBreadcrumb() {
  const setBreadcrumbTitle = (title) => {
    breadcrumbTitle.value = title || ''
  }

  const clearBreadcrumbTitle = () => {
    breadcrumbTitle.value = ''
  }

  return { breadcrumbTitle, setBreadcrumbTitle, clearBreadcrumbTitle }
}
